import "lodash"
import "featherlight/src/featherlight.js"

(function ($) {
    $(function () {
        var journalBuyBtns = $('.js-submit-journal');
        if (journalBuyBtns.length === 0) return;

        var inputDebounceWait = 200;

        journalBuyBtns.each(function (index) {
            var $this = $(this),
                foxyParams = $this.data('foxyparams'),
                $inputField = $this.parents('.journal-retailer').find('.js-journal-issue');

            $inputField.on('input', _.debounce(function (e) {
                e.preventDefault();
                var $input = $(this),
                    val = $(this).val();

                $.ajax({
                    url: universityPressThemeSettings.wordpressAjaxUrl,
                    type: "POST",
                    async: false,
                    data: {
                        action: 'journal_btn_ajax',
                        foxyParams: foxyParams,
                        journal_issue: val
                    },
                    success: function (data) {
                        if (!data.url) return;
                        var $parentBuyBtn = $input.parents('.journal-retailer').find('.journal-retailer__button');
                        $parentBuyBtn.attr("href", data.url);
                    }
                });
            }, inputDebounceWait));
        });
    });
})(jQuery);
